module.exports = __webpack_public_path__ + "img/OCURRIO.91edf549.png";